import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9e0ef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mxa-help-title pt-2",
  "data-test": "title"
}
const _hoisted_2 = { class: "mxa-help-body" }
const _hoisted_3 = { class: "mxa-help-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import BaseAccordion from '@/components/common/parts/BaseAccordion.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HelpLogin',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('body.help.login.title')), 1),
    _createVNode(BaseAccordion, {
      accordionId: "helpLogin1",
      headerTitle: _ctx.$t('body.help.login.1.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.1.body.1')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"]),
    _createVNode(BaseAccordion, {
      accordionId: "helpLogin2",
      headerTitle: _ctx.$t('body.help.login.2.header')
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.1')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.2')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.3')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.7')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.4')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.5')), 1),
          _hoisted_4,
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('body.help.login.2.body.6')), 1)
        ])
      ]),
      _: 1
    }, 8, ["headerTitle"])
  ], 64))
}
}

})